module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "story",
    attrs: {
      "id": "CreatingMissionalCulture-2.html",
      "xml:lang": "en-US"
    }
  }, [_c('h2', {
    staticClass: "Title",
    attrs: {
      "id": "heading_id_2"
    }
  }, [_vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-level-2"
  }, [_vm._v("Mom and Dad")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("I’m thankful for your love, your provision, your encouragement and the example you have been for me through the years. It has been more than I could have imagined.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-level-2"
  }, [_vm._v("My Brothers and Extended Family")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("Joe, Suzanne, Luke and Kara Woodward, I always enjoy hanging with you. Allen, Elaine, Kurt and Wil, you guys bring a lot to my life. I’m also thankful for the rest of our large tribe, my many aunts, uncles, nephews and nieces.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-level-2"
  }, [_vm._v("Pavi Thomas")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("This book would not have been written if it were not for all the conversations that we have had over the years. Thanks for your friendship and support.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-level-2"
  }, [_vm._v("Kairos Los Angeles")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("I’m grateful for your courage and willingness to experiment with new ways of approaching leadership and being the church. A special thanks to all of you who have served as equippers at the various congregations—Greg Larson, Audrey Blumber, Dave Kludt, Don Chesworth, Andy Bleyer, Joe Racek, Debbie Kim, Daniel Cunningham, Dustin James, Jeremiah Caleb, Matt Mabrey and Maria Drews (honorary equipper).")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-level-2"
  }, [_vm._v("Forge America and Alan Hirsch")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("It’s an honor to serve God’s kingdom with you. Alan, I appreciate the many conversations that we have had, and your down-to-earth way of life. Kim Hammond, thanks for welcoming me so warmly into the Forge Tribe.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-level-2"
  }, [_vm._v("Rick Mysse and RCA")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("This book became a reality because you commissioned me to write on the five equippers for the Classis of SoCal. Thanks, Rick, for your consistent encouragement.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-level-2"
  }, [_vm._v("The Turkana Tribe in Kenya")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("It has been a real privilege to walk beside you for nearly a decade. I look forward to what God has in store for us in the future. I’m especially thankful for Bishop Kaaleng, Joshua Lemuya, Moses Lorukudi, Michael Lojao as well as Mike and Jessica Thomas.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-level-2"
  }, [_vm._v("Some of My Life-Giving Friendships")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("Dustin James, Rudy Hermanto, Joe and Lisa Racek, Chris, Rachel and Elliana (godchild) Backert, Joshua and Rachael Swanson, Jim and Tracy Pace, Michael Chen, Will Andrian—I deeply appreciate each of you.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-level-2"
  }, [_vm._v("My Ministry Partner Team and GCM")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("Without you I wouldn’t be able to live out my calling in life. Thanks to my fellow GCM board members and all who work at the office. A special thanks to Tom Mauriello, KZ and Dave Meldrum-Green.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-level-2"
  }, [_vm._v("Hope International Bible Fellowship")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("I’m inspired by your example. Thanks for serving the neighborhood and us. I want to give a special thanks to Pastor Ed, Lenny and Richard.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-level-2"
  }, [_vm._v("[nlcf] in Blacksburg, VA")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("I’m thankful for all of you (1200+) whom I’ve had to opportunity to connect with in my time in Blacksburg. You helped me become a better person.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-level-2"
  }, [_vm._v("Ecclesia Network")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("I’ve thoroughly enjoyed the journey of planting more missional churches with you and experiencing your faith, hope and love along the way. You’re the best. Now help me sell this book. lol.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-level-2"
  }, [_vm._v("My Fellow MAGL’ers")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("I’m grateful to all my fellow classmates and professors in the Master of Arts in Global Leadership (MAGL) program at Fuller Theological Seminary. You guys are the real deal. I want to give a special thanks to Bob Freeman, who had the faith to start this program, to Eddie Gibbs, who made himself available for independent studies, and to Shelley Trebesch for just being you.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-level-2"
  }, [_vm._v("East Hollywood Neighborhood Council")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("I’m honored to have had the opportunity to serve with you in seeing our neighborhood become more of what it could be.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-level-2"
  }, [_vm._v("Those Who Gave Me Helpful Feedback")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("David Fitch, John Chandler, Jonathan Williams, Kurt Fredrickson, Chad Smith, Noel Hiekkenen, James Paul, J. R. Briggs, Greg Larson, Chris Backert, Heidi Simanjuntak, Jason Malec and Audrey Blumber. Thanks for taking the time out of your busy schedule to give me valuable feedback.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-level-2 para-style-override-11"
  }, [_vm._v("Those Who Went Above and Beyond Expectations")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("Maria Drews, Scott Boren, David Kludt, Samuel Smith, Scott Nelson, Keas Keasler, Nathan Elmore, Jason Lee, Joey Tomassoni, Wil Hernandez, Dustin James and Jen Collins. Your feedback was valuable beyond estimation.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-level-2"
  }, [_vm._v("InterVarsity Press")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("I’m deeply thankful for all those who supported me at IVP, especially my editor Dave Zimmerman, who gave me suggestions that made this book much better than it was. And thanks to Andrew Bronson and team—Adrianna Wright, Nathan Baker-Lutz, Leah Kiple and Suanne Camfield—for your warm welcome and for all you are doing to help me get the word out about this book.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-level-2"
  }, [_vm._v("Triune God")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("Father, thank you for your undying love. Jesus, thank you for your limitless grace. Holy Spirit, thank you for your comfort, direction and power. I am blessed, and my prayer is that this book might be a blessing to many for your glory and the good of the world.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }), _vm._v(" "), _c('p', {
    staticClass: "Body"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5713f19c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Acknowledgments.vue
// module id = 75
// module chunks = 0